import { Zap, Instagram, Twitter, Linkedin, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 py-14"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-xl bg-[#FF5722] flex items-center justify-center text-black">
                <Zap className="w-5 h-5" strokeWidth={2.5} />
              </div>
              <span className="text-lg font-bold tracking-tight text-white">
                RH<span className="text-[#FF5722]">.</span>Technology
              </span>
            </div>
            <p className="mt-4 text-sm text-zinc-500 max-w-sm leading-relaxed">
              A performance-driven digital marketing agency helping brands scale
              with Facebook Ads and Google Ads.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[Instagram, Twitter, Linkedin, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-link-${i}`}
                  className="w-9 h-9 rounded-lg border border-white/10 flex items-center justify-center text-zinc-400 hover:bg-[#FF5722] hover:border-[#FF5722] hover:text-black transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-4">
              Quick Links
            </div>
            <ul className="space-y-2.5">
              {[
                { l: "Services", h: "#services" },
                { l: "Process", h: "#process" },
                { l: "Results", h: "#results" },
                { l: "Contact", h: "#contact" },
              ].map((x) => (
                <li key={x.h}>
                  <a href={x.h} className="text-sm text-zinc-400 hover:text-[#FF7043] transition-colors">
                    {x.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-4">
              Get in Touch
            </div>
            <ul className="space-y-2.5 text-sm text-zinc-400">
              <li>hello@rhtechnology.com</li>
              <li>Mon–Fri, 9am–6pm</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-zinc-500">
            © 2026 RH Technology. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-zinc-500 font-mono">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#FF5722] pulse-dot" />
              <span>All systems operational</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
